import "./index.scss"
import { MoonLoader } from "react-spinners"
import { useState, useEffect } from "react"
const IMPORT_STEPS = [
    { title: 'Uploading resume', desc: 'Please wait while out artificial intelligence processes the information from your resume and selects the right fields' },
    {
        title: 'Filling personal information',
        desc: 'Please wait while our artificial intelligence processes the information from your resume and selects the right fields'
    },
]
const SCRATCH_STEPS = [
    { title: 'Building bridges to your future job', desc: '' },
    { title: 'Building bridges to your future job', desc: '' },
]
const SUCCESS_STEP = {
    title: 'All done!',
    desc: 'We will show you your new resume shortly..'
}
export default props => {
    const {success, option} = props;
    const [stepIdx, setStepIdx] = useState(0)
    const [dotCount, setDotCount] = useState(0);
    

    useEffect(() => {
        const dotInterval = setInterval(() => {
            setDotCount(prev => (prev + 1) % 4);
        }, 1000);
        return () => clearInterval(dotInterval);
    }, []);

    useEffect(() => {
        if (stepIdx === 0) {
            const timer = setTimeout(() => {
                setStepIdx(1);
            }, 7000);
            return () => clearTimeout(timer);
        }
    }, [stepIdx]);

    useEffect(() => {
        if (success) {
            setStepIdx(2);
        }
    }, [success]);

    let step;
    if (stepIdx === 2) {
        step = SUCCESS_STEP;
    } else {
        step = option === 'import' ? IMPORT_STEPS[stepIdx] : SCRATCH_STEPS[stepIdx];
    }

    return (
        <div className="create-loader">
            <div className="create-loader-content">
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '0 auto 20px' }}>
                    <MoonLoader />
                </div>
                <h1 className="intro-step-title">
                  <span>{step.title}</span>
                  <span className="dots-animate">{'.'.repeat(dotCount)}</span>
                </h1>
                <div className="create-loader-desc">{step.desc}</div>
            </div>
        </div>
    )
}